import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import daysPassed from 'src/app/shared/constants/daysPassed';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile-viewers',
  templateUrl: './profile-viewers.component.html',
  styleUrls: ['./profile-viewers.component.scss']
})
export class ProfileViewersComponent  {
  @Input() allUserIds: any[] = [];
  textLoading = 'Loading viewers...';

  labelMap: any = {
    startup: 'Startup',
    corporate: 'Corporate',
    investor: 'Investor',
    mentor: 'Mentor',
    service_provider: 'Service Provider',
    partner: 'Partner',
    other: 'Other',
    job_seeker: 'Job Seeker',
    program_office: 'Program Office',
    individual: 'Individual',
  };
 
 

  constructor(public activeModal: NgbActiveModal,private router: Router,) {}

  closeModal() {
    this.activeModal.dismiss();
  }
  daysPassed(date) {
    return daysPassed(date);
  }

  openDetailsView(viewerData) {

    const accountTypes = {
      startup: 'startups',
      corporate: 'corporates',
      investor: 'investors',
      mentor: 'mentors',
      service_provider: 'service-provider',
      partner: 'partners',
      program_office: 'program-office-members',
      individual: 'individuals',
    };
    const accountTypeValue = accountTypes[viewerData.viewerAccountType];
    const slug = (viewerData.viewerCompanyName || '').split(' ').join('-').toLocaleLowerCase();
    const commands: any[] = ['/' + accountTypeValue + '/profile/' + viewerData.viewerProfileUUID];
    if (slug) { commands.push(slug); }
    const url = this.router.serializeUrl(this.router.createUrlTree(commands));
      window.open(url, '_blank');

  }
}
